import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { saveLastRoute } from "./lib/last-route";

export const queryClient = new QueryClient({
  defaultOptions: {
    // Higher staleTime keeps cellular users from refetching on every nav.
    // Individual queries can override (e.g. uploads polling).
    queries: { staleTime: 60_000, refetchOnWindowFocus: false },
  },
});

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: false,
});

// Persist the last in-app route so a WKWebView content-process restart
// (e.g. OOM from rendering a large HEIC) lands users back where they were
// instead of dumping them on the marketing landing page.
router.subscribe("onResolved", (e) => {
  try {
    const path = e.toLocation?.pathname;
    if (path) saveLastRoute(path);
  } catch {
    /* noop */
  }
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

